import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Nav, NavItem, NavLink } from 'reactstrap';
import { RootState } from 'store'
import AddCompetitionReportModal from 'Components/CompetitionAnalysis/CompetitionGroup/AddCompetitionReportModal';
import Competitors from './Competitors';
import Reports from './Reports';
import AddCompetitorModal from 'Components/CompetitionAnalysis/AddCompetitorModal';
import { CompetitionGroup } from 'types/competition-analysis';

const CompetitorAnalysis = () => {


    const [activeTab, setActiveTab] = useState('competitors');

    const [addReport, setAddReport] = useState(false);
    const [addCompetitor, setAddCompetitor] = useState(false);
    const [editReport, setEditReport] = useState<CompetitionGroup | null>(null)

    const [tabs, setTabs] = useState([
        {
            label: 'Competitors',
            value: 'competitors',
            sort: 1,

        },
        {
            label: 'Reports',
            value: 'reports',
            sort: 2
        }
    ])



    const sortedTabs = tabs.sort((a, b) => a.sort - b.sort)

    useEffect(() => {
        setActiveTab(sortedTabs[0].value)
    }, [sortedTabs])

    return (
        <>
            <div className="campaign-page">
                <h1 className="campaign-page-title">Competitors</h1>
                <div className="d-flex justify-content-between align-items-center campaign-page-info flex-column flex-lg-row mt-4 gap-2 gap-lg-0">
                    <Nav tabs className="nav nav-tabs nav-tabs-custom nav-primary nav-justified campaign-nav w-100 w-lg-50">
                        {
                            sortedTabs.map((tab) => (
                                <NavItem className='campaign-nav-item' key={tab.value}>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={`campaign-nav-link ${activeTab === tab.value && 'active-campaign-nav'} text-start`}
                                        onClick={() => setActiveTab(tab.value)}
                                    >
                                        {tab.label}
                                    </NavLink>
                                </NavItem>
                            ))
                        }
                    </Nav>
                    {
                        activeTab === 'competitors' && <button onClick={() => setAddCompetitor(true)} className="theme-btn theme-btn-md link-as-btn btn-gradient"><i className='mdi mdi-plus fs-5 fw-bold me-1'></i> Add Competitor</button>
                    }
                    {
                        activeTab === 'reports' && <button onClick={() => setAddReport(true)} className="theme-btn theme-btn-md link-as-btn btn-gradient"><i className='mdi mdi-plus fs-5 fw-bold me-1'></i> Create Report</button>
                    }
                </div>
                {
                    activeTab === 'competitors' &&
                    <Competitors />
                }
                {
                    activeTab === 'reports' &&
                    <Reports onEdit={(report) => setEditReport(report)} />
                }

            </div>
            <AddCompetitionReportModal
                isOpen={addReport || !!(editReport)}
                onClose={() => {
                    setAddReport(false)
                    setEditReport(null);
                }}
                selectedReport={editReport}
            />
            <AddCompetitorModal
                isOpen={addCompetitor}
                onClose={() => setAddCompetitor(false)}
            />
        </>
    )
}

export default CompetitorAnalysis
